import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";

const AirFreight = () => {
  return (
    <>
      <Helmet>
        <title>Air Freight | Trans World Shipping</title>
        <meta
          name="description"
          content="Explore our comprehensive air freight services for efficient global shipping solutions."
        />
        <link
          rel="canonical"
          href="https://transworldshippingcompany.com/services/airfreight"
        />
      </Helmet>

      <TheAirFreight>
        <div className="airfreight-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Air Freight</h1>
            <p>
              Global air cargo solutions with reliable charter and consolidation
              services
            </p>
          </div>
        </div>

        <div className="airfreight-container">
          <div className="intro-section">
            <p>
              Our airfreight division: <strong>TransEurope Aircargo</strong> is
              recognized in the industry for their reliable charter and
              consolidation services to all major airports.
            </p>
          </div>

          <div className="mission-section">
            <p>
              We aim to be the most efficient, customized and cost effective
              aircargo operator in the international market.
            </p>
          </div>

          <div className="coverage-section">
            <p>
              We are represented at all major international gateways, and
              operate and provide combined air and truck express services to
              every possible destination around the globe – on time – to meet
              your deadline.
            </p>
          </div>

          <div className="quality-section">
            <p>We are a quality global airfreight logistics provider.</p>
          </div>
        </div>
      </TheAirFreight>
    </>
  );
};

const TheAirFreight = styled.div`
  width: 100%;
  background: #ffffff;

  .airfreight-hero {
    position: relative;
    width: 100%;
    height: 40vh;
    min-height: 300px;
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);

    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(
        circle at 30% 50%,
        rgba(212, 175, 55, 0.1) 0%,
        transparent 70%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      width: 100%;
      padding: 0 2rem;
      z-index: 1;

      h1 {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.2rem;
        opacity: 0.9;
      }
    }
  }

  .airfreight-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 4rem 2rem;
  }

  .intro-section {
    text-align: center;
    margin-bottom: 2.5rem;

    p {
      font-size: 1.2rem;
      color: #0b1e33;
      line-height: 1.7;

      strong {
        color: #d4af37;
        font-weight: 700;
      }
    }
  }

  .mission-section {
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);
    padding: 2.5rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 2rem;

    p {
      color: white;
      font-size: 1.1rem;
      line-height: 1.7;
      font-weight: 500;
    }
  }

  .coverage-section {
    background: #f8f9fa;
    padding: 2.5rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 2rem;
    border: 1px solid #e2e8f0;

    p {
      font-size: 1.1rem;
      color: #4a5568;
      line-height: 1.7;
    }
  }

  .quality-section {
    text-align: center;
    padding: 2rem;

    p {
      font-size: 1.3rem;
      color: #d4af37;
      font-weight: 600;
      letter-spacing: 1px;
    }
  }

  @media screen and (max-width: 900px) {
    .airfreight-hero .hero-content h1 {
      font-size: 2.5rem;
    }

    .airfreight-container {
      padding: 3rem 1.5rem;
    }

    .intro-section p {
      font-size: 1.1rem;
    }

    .mission-section p,
    .coverage-section p {
      font-size: 1rem;
    }

    .quality-section p {
      font-size: 1.1rem;
    }
  }

  @media screen and (max-width: 768px) {
    .airfreight-hero {
      min-height: 250px;

      .hero-content h1 {
        font-size: 2rem;
      }

      .hero-content p {
        font-size: 1rem;
      }
    }

    .airfreight-container {
      padding: 2rem 1rem;
    }

    .intro-section p {
      font-size: 1rem;
    }

    .mission-section,
    .coverage-section {
      padding: 1.5rem;
    }
  }

  @media screen and (max-width: 600px) {
    .airfreight-hero .hero-content h1 {
      font-size: 1.6rem;
    }

    .intro-section p {
      font-size: 0.95rem;
    }

    .mission-section p,
    .coverage-section p {
      font-size: 0.9rem;
    }

    .quality-section p {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 480px) {
    .airfreight-hero .hero-content h1 {
      font-size: 1.3rem;
    }

    .airfreight-hero .hero-content p {
      font-size: 0.9rem;
    }
  }
`;

export default AirFreight;
